import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-video-pop-up',
  templateUrl: './video-pop-up.component.html',
  styleUrls: ['./video-pop-up.component.scss']
})
export class VideoPopUpComponent implements OnInit {
  @Input() public videoLink;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.close();
  }


}
